import { initializeApp } from 'firebase/app';
import { getAuth, signInAnonymously } from 'firebase/auth';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DB_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_SENDER_ID, // ✅ ADDED
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

let firebaseApp = null;

if (firebaseConfig.apiKey) {
  firebaseApp = initializeApp(firebaseConfig);

  signInAnonymously(getAuth(firebaseApp))
    .then(() => console.log('Firebase anonymous login success'))
    .catch(err =>
      console.error('Firebase auth error:', err.code, err.message)
    );
} else {
  console.error(
    'Firebase config missing REACT_APP_FIREBASE_API_KEY — skipping init'
  );
}

export default firebaseApp;
